export default __webpack_public_path__ + "static/media/ball.b060cfad.svg";